var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c("list-edition-toolbar", {
        attrs: { buttons: _vm.toolbarButtons },
        on: {
          edit: function($event) {
            _vm.editionDisabled = false
          },
          delete: function($event) {
            _vm.deleteDialog = true
          },
          save: _vm.save,
          cancel: _vm.cancel
        }
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "v-layout",
            {
              staticClass: "activity-form-container",
              attrs: { row: "", wrap: "" }
            },
            [
              _c("input-field", {
                attrs: {
                  label: _vm.$t("Title"),
                  "variable-name": "title",
                  "input-type": "text",
                  size: "small",
                  "field-disabled": _vm.editionDisabled,
                  required: ""
                },
                model: {
                  value: _vm.editedActivity.title,
                  callback: function($$v) {
                    _vm.$set(_vm.editedActivity, "title", $$v)
                  },
                  expression: "editedActivity.title"
                }
              }),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  label: _vm.$t("DueDate"),
                  "variable-name": "due_date",
                  "input-type": "datetime",
                  size: "small",
                  "field-disabled":
                    _vm.editionDisabled || _vm.activity.state === "closed",
                  required: _vm.activity.due_date !== null
                },
                model: {
                  value: _vm.editedActivity.due_date,
                  callback: function($$v) {
                    _vm.$set(_vm.editedActivity, "due_date", $$v)
                  },
                  expression: "editedActivity.due_date"
                }
              }),
              _vm._v(" "),
              _c(
                "input-field",
                {
                  attrs: {
                    label: _vm.$t("State"),
                    value: _vm.activity.state,
                    "variable-name": "state",
                    "input-type": "other",
                    size: "small",
                    "field-disabled": true
                  }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", "align-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c("activity-task-status-icon", {
                            attrs: { status: _vm.activity.state }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-flex", { staticClass: "ml-2" }, [
                        _c("div", [
                          _vm._v(_vm._s(_vm.getStateLabel(_vm.activity.state)))
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  label: _vm.$t("Description"),
                  "variable-name": "description",
                  "input-type": "textarea",
                  size: "medium",
                  "field-disabled": _vm.editionDisabled
                },
                model: {
                  value: _vm.editedActivity.description,
                  callback: function($$v) {
                    _vm.$set(_vm.editedActivity, "description", $$v)
                  },
                  expression: "editedActivity.description"
                }
              }),
              _vm._v(" "),
              _c(
                "input-field",
                {
                  attrs: {
                    label: _vm.$t("ApprovalType"),
                    "input-type": "other",
                    size: "small",
                    value: _vm.approvalType
                  }
                },
                [
                  _c("treeselect", {
                    staticClass: "form-input-select",
                    attrs: {
                      value: _vm.approvalType,
                      options: _vm.approvalTypeOptions,
                      disabled: _vm.editionDisabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateTasksAutoApproval($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            {
              staticStyle: {
                position: "relative",
                width: "100%",
                height: "100px"
              }
            },
            [
              _c("loading-spinner", {
                attrs: {
                  active: _vm.loading,
                  "is-full-page": false,
                  color: "#4fa2b7",
                  "background-color": "transparent"
                },
                on: {
                  "update:active": function($event) {
                    _vm.loading = $event
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialog,
          title: _vm.$t("DeleteItem"),
          content:
            _vm.$t("DeleteConfirmation") + " " + _vm.activity.title + "?",
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: function($event) {
            _vm.deleteDialog = false
          },
          secondaryAction: _vm.remove
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2269ce70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2269ce70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/ActivityDetails/ActivityDetailsForm.vue
// module id = null
// module chunks = 